import { render, staticRenderFns } from "./add-credentials.vue?vue&type=template&id=081272f4&scoped=true&"
import script from "./add-credentials.vue?vue&type=script&lang=js&"
export * from "./add-credentials.vue?vue&type=script&lang=js&"
import style0 from "./add-credentials.vue?vue&type=style&index=0&id=081272f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081272f4",
  null
  
)

export default component.exports